<template>
    <span class="badge" :class="badgeClass">
        <span v-if="indicator" class="badge__indicator" />
        <slot />
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export type BadgeType = 'info' | 'success' | 'warning' | 'danger' | 'error' | 'muted';

interface Props {
    type?: BadgeType;
    color?: string;
    indicator?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    type: 'muted',
    color: undefined,
    indicator: false,
});

const badgeClass = computed(() => {
    const classes: string[] = [];

    if (props.color) {
        classes.push(`badge--color-${props.color}`);
    } else {
        classes.push(`badge--${props.type}`);
    }

    if (props.indicator) {
        classes.push('badge--indicator');
    }

    return classes;
});
</script>
